import { render } from "./features-showcase-pending-user-cta.vue?vue&type=template&id=8e8134e6&scoped=true&ts=true"
import script from "./features-showcase-pending-user-cta.vue?vue&type=script&lang=ts"
export * from "./features-showcase-pending-user-cta.vue?vue&type=script&lang=ts"

import "./features-showcase-pending-user-cta.vue?vue&type=style&index=0&id=8e8134e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e8134e6"]])

export default __exports__